const PortfolioDataList = [
  {
    id: 8,
    title: "PerfectGift",
    description:
      "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:..",
    src: require("../assets/perfect-gift-2.png"),
    alt: "Image",
    dataLine: "PerfectGift",
    additionalImages: [
      require("../assets/perfect-gift-1.png"),
      require("../assets/perfect-gift-2.png"),
      require("../assets/perfect-gift-3.jpg"),
      require("../assets/perfect-gift-4.png"),
    ],
    portfolioDescription: {
      ProjectDescription:
        "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:",
      keyfeatures: "Key Features",

      TrailExploration:
        "Users can customize gift cards for any occasion with unique designs and messages.Both physical and digital gift cards are available.",
      ReviewandFeedback:
        "Instant delivery via text or email, making it convenient for last-minute gifting.",
      EventParticipation:
        "Physical cards can be shipped quickly, ensuring timely delivery for special occasions.",
      communityPage:
        " There’s an option to buy gift cards in bulk, making it ideal for corporate gifting or large events.",
      UserandHostProfiles:
        "Gift cards are available for popular brands like Amazon, Starbucks, McDonald's, and more.",
      SocialInteraction:
        "The platform offers customizable VISA gift cards that can be used anywhere VISA is accepted.",
    },
  },
  {
    id: 2,
    title: "Giftya Mobile App",
    description:
      "GiftYa - the gift card app that allows you to send a gift card in a new way! From the makers of Giftcards.com, GifYa is an app that completely streamlines and...",
    src: require("../assets/giftya.jpeg"),
    alt: "Image",
    dataLine: "Check My Giftya App",
    additionalImages: [
      require("../assets/giftya-1.png"),
      require("../assets/giftya-3.png"),
      require("../assets/giftya-2.png"),
      require("../assets/giftya-5.png"),
    ],
    portfolioDescription: {
      ProjectDescription:
        "GiftYa - the gift card app that allows you to send a gift card in a new way! From the makers of Giftcards.com, GifYa is an app that completely streamlines and simplifies the gift card gift-giving process! We have reinvented gift sharing to be more accessible, personalized, and thoughtful than ever!",
      keyfeatures: "The giftya download",

      TrailExploration:
        "I worked on the mobile app project, from design to development and releasing the apps to the Apple App Store and Google Play Store. We were a team of eight persons working on the GiftYa project two mobile app developers two website developers and two backend developers one product manager, one product designer.",
      ReviewandFeedback:
        "Developing mobile apps with React Native. Using GIT for version control management. Using Redux saga for state management and async operations. Afterward, updated API integration with react query. We used typescript for GiftYa app development. I added social logins like Facebook, Google, and Apple. I implemented Stripe, Google Pay, Apple Pay, and PayPal. We're also introducing Amazon Pay. User can use these payment methods to buy gifts for their loved ones.",
      EventParticipation:
        "Join outdoor events hosted by community members or create your own events as a host, making it easy to connect with others who share your passion.",
      communityPage:
        " Engage with a social media-like feed where users can post images, videos, and updates. Interact with posts through comments and likes, fostering a sense of community.",
      UserandHostProfiles:
        "Manage your profile, connect with friends, and participate in events. Hosts have the ability to create and manage events, while users can join and engage with them.",
      SocialInteraction:
        "Send friend requests, message other users, and build your network, just like on popular social media platforms.",
      describe:
        "The Social Adventure App is more than just a hiking tool; it's a social platform that brings together outdoor enthusiasts to share, connect, and explore the world together. Whether you're planning your next hike or looking to join a community event, this app provides everything you need for a socially engaging outdoor experience.",
      ProdectDetiled: " Saudi Arabia",
    },
  },

  {
    id: 3,
    title: "Giftya Web",
    description:
      "We created the next-generation of gifting that can never be lost or stolen. GiftYa is the true digital gift card that sends your gift when they need it most.",
    src: require("../assets/giftya-web-1.png"),
    alt: "Image",
    dataLine: "Giftya-wab",
    size: { width: 200, height: 'auto' },
    additionalImages: [
      require("../assets/giftya-web-1.png"),
      require("../assets/giftya-web-2.png"),
      require("../assets/giftya-web-3.jpg"),
      require("../assets/giftya-web-4.png"),
    ],
    portfolioDescription: {
      ProjectDescription:
        "We created the next-generation of gifting that can never be lost or stolen. GiftYa is the true digital gift card that sends your gift when they need it most.",
      keyfeatures: "Key Features",
      TrailExploration:
        "Send gifts via text or email within seconds.",
      ReviewandFeedback:
        "Add a custom message, photo, or video to make the gift special.",
      EventParticipation:
        "Recipients can link the gift to their credit or debit card and spend it anywhere GiftYa is accepted.",
      communityPage:
        " Since the gift is digital and linked to a card, there’s no risk of losing a physical card.",
      UserandHostProfiles:
        "GiftYa partners with numerous popular brands, restaurants, and retailers.",
      SocialInteraction:
        "Choose a merchant or let the recipient decide.Add a personal touch with a message or photo.Send it instantly via text or email.The recipient links the gift to their card and starts spending.GiftYa simplifies gifting, making it thoughtful, fast, and stress-free.",

    },
  },
  {
    id: 6,
    title: "Granny app",
    description:
      "Granny is a popular horror game developed by DVloper, available for both Android and iOS platforms. In this game, you're trapped in a creepy house, and your main goal is to escape while avoiding the terrifying Granny, who hears every sound you make...",
    src: require("../assets/granny.jpeg"),
    alt: "Image",
    dataLine: "Granny app",
    additionalImages: [
      require("../assets/granny-1.png"),
      require("../assets/granny-2.png"),
      require("../assets/granny-3.png"),
      require("../assets/granny-4.png"),
    ],
    portfolioDescription: {
      ProjectDescription:
        "Granny is a popular horror game developed by DVloper, available for both Android and iOS platforms. In this game, you're trapped in a creepy house, and your main goal is to escape while avoiding the terrifying Granny, who hears every sound you make.",
      keyfeatures: "Key Features",

      TrailExploration:
        "The game offers a dark, intense environment that keeps players on edge.",
      ReviewandFeedback:
        "Granny can hear every noise. If you drop something or make a sound, she'll come running.",
      EventParticipation:
        "You can hide under beds, inside closets, or behind objects to avoid getting caught.",
      communityPage:
        " You only have 5 days to escape. Every time Granny catches you, you lose one day.",
      UserandHostProfiles:
        "To escape, you must solve puzzles, find keys, and unlock doors while staying silent.",
    },
  },
  {
    id: 1,
    title: "HomeSchooling",
    description:
      "Homeschooling means teaching your child at home, where you can guide them closely and help them learn in fun, hands-on ways...",
    src: require("../assets/homeSchooling.png"),
    alt: "Image",
    dataLine: "HomeSchooling",
    additionalImages: [
      require("../assets/home_sch_five.png"),
      require("../assets/home_sch_six.png"),
      require("../assets/Home_Schooling_four.png"),
      require("../assets/Home_Schooling_three.png"),
    ],
    portfolioDescription: {
      ProjectDescription:
        "Homeschooling means teaching your child at home, where you can guide them closely and help them learn in fun, hands-on ways. Instead of just paying high school fees, you can buy learning toys and activities that will actually help your child grow. Homeschooling lets you teach through real-life experiences. For example, when you go to the mall, let your child pay using the ATM. When buying groceries, give them cash to pay. Take them to parks and play areas, or set up activities at home to help them learn. From ages 2 to 6, children need your time and attention. With homeschooling, they learn through play and everyday activities, rather than just from books. This makes learning more fun and meaningful!",
    },
  },
  {
    id: 16,
    title: "Islam Basics",
    description:
      "Islam Basics is a beginner-friendly app designed to help users understand the core teachings of Islam in a simple and interactive way. It covers essential topics like the Five Pillars of Islam, daily prayers, and important Islamic values...",
    src: require("../assets/islamBasics.png"),
    alt: "Islam Basics App Image",
    dataLine: "Islam Basics",
    additionalImages: [
      require("../assets/islam_screen_one.png"),
      require("../assets/islam_screen_two.png"),
      require("../assets/islam_screen_three.png"),
      require("../assets/islam_screen_four.png"),
      require("../assets/islam_screen_five.png"),
      require("../assets/islam_screen_six.png"),
      require("../assets/islam_screen_seven.png"),
    ],
    portfolioDescription: {
      ProjectDescription:
        "Islam Basics is a simple and user-friendly mobile app that introduces users to the foundational teachings of Islam. The app includes sections on the Five Pillars of Islam—Shahada (faith), Salah (prayer), Zakat (charity), Sawm (fasting), and Hajj (pilgrimage). It also guides users on how to perform daily prayers with step-by-step instructions and audio support. The app features child-friendly illustrations and interactive activities to make learning engaging for all ages. Whether you're new to Islam or want to teach your kids, Islam Basics provides a peaceful and informative learning experience rooted in authenticity and simplicity.",
    },
  },
  {
    id: 4,
    title: "Clublax",
    description:
      "The Club Sports Organization LLC (“us”, “we”, or “our”) operates the www.clublacrosse.org website and the mobile application (hereinafter referred to as the “Service”).",
    src: require("../assets/clublex.jpeg"),
    alt: "Image",
    dataLine: "Clubax",
    additionalImages: [
      require("../assets/clublax-1.png"),
      require("../assets/clublax-2.png"),
      require("../assets/clublax-3.png"),
    ],
    portfolioDescription: {
      ProjectDescription:
        "The Club Sports Organization LLC (“us”, “we”, or “our”) operates the www.clublacrosse.org website and the mobile application (hereinafter referred to as the “Service”).This page informs you of our policies regarding the collection, use and disclosure of personal data when you use our Service and the choices you have associated with that data.",
      keyfeatures: "Key Features",
      TrailExploration:
        "Personal information such as email addresses, names, phone numbers, and addresses are collected when users interact with the Service. Additionally, Usage Data like IP addresses, browser types, and pages visited are gathered to enhance user experience.",
      ReviewandFeedback:
        " Collected data is utilized to provide and maintain the Service, notify users about changes, offer customer support, and monitor Service usage.",
      EventParticipation:
        "The Service employs cookies to track user activity and store certain information. Users can configure their browsers to refuse cookies; however, this may affect the availability of some Service features.",
      communityPage:
        "Personal Data may be shared with Service Providers to facilitate the Service, with affiliates, business partners, or during business transfers, ensuring that recipients adhere to similar privacy standards.",
      UserandHostProfiles:
        " Appropriate measures are in place to protect user data. However, no method of transmission over the internet is entirely secure, and absolute security cannot be guaranteed.",
      SocialInteraction:
        " Depending on jurisdiction, users may have rights to access, rectify, delete, or restrict the processing of their Personal Data. The policy provides contact information for users to exercise these rights.",
      describe:
        "The Privacy Policy may be updated periodically, with changes posted on the website. Users are encouraged to review the policy regularly for any modifications.",
    },
  },
  {
    id: 5,
    title: "Fert app",
    description:
      "is a fitness and lifestyle platform designed to motivate users by turning daily activities into challenges and rewarding progress. It combines social engagement with goal tracking, making fitness more interactive and fun...",
    src: require("../assets/fert.jpeg"),
    alt: "Image",
    dataLine: "Fert app",
    additionalImages: [
      require("../assets/fert-1.png"),
      require("../assets/fert-2.png"),
      require("../assets/fert-3.png"),

    ],
    portfolioDescription: {
      ProjectDescription:
        "is a fitness and lifestyle platform designed to motivate users by turning daily activities into challenges and rewarding progress. It combines social engagement with goal tracking, making fitness more interactive and fun.",
      keyfeatures: "Key Features",

      TrailExploration:
        "Easily set personal goals for fitness, wellness, or daily habits.",
      ReviewandFeedback:
        "Join or create challenges with friends or the community to stay motivated.",
      EventParticipation:
        "Monitor your steps, workouts, and achievements in real-time.",
      communityPage:
        " Cheer on friends, share progress, and compete in friendly challenges.",
      UserandHostProfiles:
        "Simple, clean design for easy navigation and goal management.The Feat App combines personal achievement with social motivation, making goal-setting more engaging and rewarding.",
    },
  },
  {
    id: 7,
    title: "NextHire",
    description:
      "The NextHire app is an innovative recruitment platform that connects job seekers and employers beyond traditional resumes. It allows candidates to create comprehensive profiles with.",
    src: require("../assets/next-hire.jpeg"),
    alt: "Image",
    dataLine: "Next app",
    additionalImages: [
      require("../assets/next-1.png"),
      require("../assets/next-2.png"),
      require("../assets/next-3.png"),
      require("../assets/next-4.png"),
    ],
    portfolioDescription: {
      ProjectDescription:
        "The NextHire app is an innovative recruitment platform that connects job seekers and employers beyond traditional resumes. It allows candidates to create comprehensive profiles with.",
      keyfeatures: "Key Features",

      TrailExploration:
        "Candidates can upload photos, videos, resumes, and portfolios, giving employers a well-rounded view.",
      ReviewandFeedback:
        "The app offers built-in video call functionality, making interviews more efficient and flexible.",
      EventParticipation:
        "Employers can shortlist candidates based on their profiles, avoiding initial screening interviews and speeding up the hiring process.",
      communityPage:
        "  NextHire is available for iOS users on the App Store.",
    },
  },
  {
    id: 9,
    title: "Appal",
    description:
      "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:..",
    src: require("../assets/appol.png"),
    alt: "Image",
    dataLine: "Appal",
    additionalImages: [
      require("../assets/verify acc phone.jpg"),
      require("../assets/sell product.jpg"),
      require("../assets/sell product (1).jpg"),
      require("../assets/profile.jpg"),
      require("../assets/productbid.jpg"),
      require("../assets/product.jpg"),
      require("../assets/Your adds full.jpg"),
      require("../assets/onboarding.jpg"),
      require("../assets/notification.jpg"),
      require("../assets/edit profile.jpg"),
      require("../assets/edit post.jpg"),
      require("../assets/create acc phone.jpg"),
      require("../assets/verify acc phone.jpg"),
      require("../assets/Chats.jpg"),
      require("../assets/Chats texting.jpg"),
      require("../assets/categories final.jpg"),
      require("../assets/bid.jpg"),
    ],
    portfolioDescription: {
      ProjectDescription:
        "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:",
      keyfeatures: "Key Features",

      TrailExploration:
        "Users can customize gift cards for any occasion with unique designs and messages.Both physical and digital gift cards are available.",
      ReviewandFeedback:
        "Instant delivery via text or email, making it convenient for last-minute gifting.",
      EventParticipation:
        "Physical cards can be shipped quickly, ensuring timely delivery for special occasions.",
      communityPage:
        " There’s an option to buy gift cards in bulk, making it ideal for corporate gifting or large events.",
      UserandHostProfiles:
        "Gift cards are available for popular brands like Amazon, Starbucks, McDonald's, and more.",
      SocialInteraction:
        "The platform offers customizable VISA gift cards that can be used anywhere VISA is accepted.",
    },
  },
  {
    id: 10,
    title: "Blood donation",
    description:
      "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:..",
    src: require("../assets/blood-donating.png"),
    alt: "Image",
    dataLine: "Blood donation",
    additionalImages: [
      require("../assets/About us.png"),
      require("../assets/log in.png"),
      require("../assets/Contact us.png"),
      require("../assets/Donation.png"),
      require("../assets/Donor.png"),
      require("../assets/request.png"),

    ],
    portfolioDescription: {
      ProjectDescription:
        "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:",
      keyfeatures: "Key Features",

      TrailExploration:
        "Users can customize gift cards for any occasion with unique designs and messages.Both physical and digital gift cards are available.",
      ReviewandFeedback:
        "Instant delivery via text or email, making it convenient for last-minute gifting.",
      EventParticipation:
        "Physical cards can be shipped quickly, ensuring timely delivery for special occasions.",
      communityPage:
        " There’s an option to buy gift cards in bulk, making it ideal for corporate gifting or large events.",
      UserandHostProfiles:
        "Gift cards are available for popular brands like Amazon, Starbucks, McDonald's, and more.",
      SocialInteraction:
        "The platform offers customizable VISA gift cards that can be used anywhere VISA is accepted.",
    },
  },

  {
    id: 11,
    title: "Event planning app",
    description:
      "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:..",
    src: require("../assets/event-planing.jpeg"),
    alt: "Image",
    dataLine: "Event planning app",
    additionalImages: [
      require("../assets/WhatsApp Image 2025-01-10 at 6.18.52 PM (1).jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 6.18.52 PM.jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 7.27.25 PM.jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 7.27.26 PM (1).jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 7.27.26 PM.jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 7.27.28 PM.jpeg"),
      require("../assets/WhatsApp Image 2025-01-13 at 7.55.05 PM.jpeg"),
      require("../assets/WhatsApp Image 2025-01-13 at 7.55.07 PM.jpeg"),
    ],
    portfolioDescription: {
      ProjectDescription:
        "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:",
      keyfeatures: "Key Features",

      TrailExploration:
        "Users can customize gift cards for any occasion with unique designs and messages.Both physical and digital gift cards are available.",
      ReviewandFeedback:
        "Instant delivery via text or email, making it convenient for last-minute gifting.",
      EventParticipation:
        "Physical cards can be shipped quickly, ensuring timely delivery for special occasions.",
      communityPage:
        " There’s an option to buy gift cards in bulk, making it ideal for corporate gifting or large events.",
      UserandHostProfiles:
        "Gift cards are available for popular brands like Amazon, Starbucks, McDonald's, and more.",
      SocialInteraction:
        "The platform offers customizable VISA gift cards that can be used anywhere VISA is accepted.",
    },
  },
  {
    id: 13,
    title: "Fitness App",
    description:
      "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:..",
    src: require("../assets/Untitled design (42).png"),
    alt: "Image",
    dataLine: "Fitness App",
    additionalImages: [
      require("../assets/WhatsApp Image 2025-01-10 at 4.58.53 PM (1).jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 4.58.53 PM (2).jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 4.58.53 PM (3).jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 4.58.53 PM.jpeg"),

    ],
    portfolioDescription: {
      ProjectDescription:
        "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:",
      keyfeatures: "Key Features",

      TrailExploration:
        "Users can customize gift cards for any occasion with unique designs and messages.Both physical and digital gift cards are available.",
      ReviewandFeedback:
        "Instant delivery via text or email, making it convenient for last-minute gifting.",
      EventParticipation:
        "Physical cards can be shipped quickly, ensuring timely delivery for special occasions.",
      communityPage:
        " There’s an option to buy gift cards in bulk, making it ideal for corporate gifting or large events.",
      UserandHostProfiles:
        "Gift cards are available for popular brands like Amazon, Starbucks, McDonald's, and more.",
      SocialInteraction:
        "The platform offers customizable VISA gift cards that can be used anywhere VISA is accepted.",
    },
  },
  {
    id: 14,
    title: "GPT App",
    description:
      "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:..",
    src: require("../assets/WhatsApp Image 2025-01-10 at 7.34.06 PM.jpeg"),
    alt: "Image",
    dataLine: "GPT App",
    additionalImages: [
      require("../assets/WhatsApp Image 2025-01-10 at 7.34.06 PM (1).jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 7.34.07 PM.jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 7.34.08 PM.jpeg"),
      require("../assets/WhatsApp Image 2025-01-10 at 7.34.07 PM (2).jpeg"),

    ],
    portfolioDescription: {
      ProjectDescription:
        "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:",
      keyfeatures: "Key Features",

      TrailExploration:
        "Users can customize gift cards for any occasion with unique designs and messages.Both physical and digital gift cards are available.",
      ReviewandFeedback:
        "Instant delivery via text or email, making it convenient for last-minute gifting.",
      EventParticipation:
        "Physical cards can be shipped quickly, ensuring timely delivery for special occasions.",
      communityPage:
        " There’s an option to buy gift cards in bulk, making it ideal for corporate gifting or large events.",
      UserandHostProfiles:
        "Gift cards are available for popular brands like Amazon, Starbucks, McDonald's, and more.",
      SocialInteraction:
        "The platform offers customizable VISA gift cards that can be used anywhere VISA is accepted.",
    },
  },
  {
    id: 15,
    title: "Insta link clone App",
    description:
      "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:..",
    src: require("../assets/insta-clone.png"),
    alt: "Image",
    dataLine: "Insta link clone App",
    additionalImages: [
      require("../assets/Varifying Phone Number.jpg"),
      require("../assets/Social.jpg"),
      require("../assets/Splash.jpg"),
      require("../assets/Upcoming Event.jpg"),

    ],
    portfolioDescription: {
      ProjectDescription:
        "The website PerfectGift.com specializes in personalized gift cards and eGifts. Here's a detailed overview based on the image you shared:",
      keyfeatures: "Key Features",

      TrailExploration:
        "Users can customize gift cards for any occasion with unique designs and messages.Both physical and digital gift cards are available.",
      ReviewandFeedback:
        "Instant delivery via text or email, making it convenient for last-minute gifting.",
      EventParticipation:
        "Physical cards can be shipped quickly, ensuring timely delivery for special occasions.",
      communityPage:
        " There’s an option to buy gift cards in bulk, making it ideal for corporate gifting or large events.",
      UserandHostProfiles:
        "Gift cards are available for popular brands like Amazon, Starbucks, McDonald's, and more.",
      SocialInteraction:
        "The platform offers customizable VISA gift cards that can be used anywhere VISA is accepted.",
    },
  },

];

export default PortfolioDataList;
